import './assets/css/App.css';
import { Routes, Route } from 'react-router-dom';
import {} from 'react-router-dom';
import AdminLayout from './layouts/admin';
import AuthPage from './views/auth/signIn'
import {
  ChakraProvider,
  // extendTheme
} from '@chakra-ui/react';
import initialTheme from './theme/theme'; //  { themeGreen }
import { useState } from 'react';
import ProtectedRoutes from './ProtectedRoutes';
// Chakra imports

function App() {
  // eslint-disable-next-line
  const [currentTheme, setCurrentTheme] = useState(initialTheme);
  return (
    <ChakraProvider theme={currentTheme}>
    
      <Routes>
      <Route path="/" element={<AuthPage/>}/>
        <Route path="auth/sign-in" element={<AuthPage/>}/>
        <Route exact path='admin/*' element={<ProtectedRoutes><AdminLayout/></ProtectedRoutes>}/>
      </Routes>
    </ChakraProvider>
  );
}

export default App;
